import { AuditUseCase, AuditTask, AuditResult, TASK_STATUS, RESULT_STATUS } from "./types";

// Placeholder alias used in sample data. Thunks replace this with the
// logged-in user so isMine() matches, while preserving other reviewer IDs.
export const SAMPLE_AUDITOR_ALIAS = "sample-auditor";

// TODO: Remove all sample data once audit v2 migration is done
export const SAMPLE_USE_CASES: AuditUseCase[] = [
  { id: "uc-safety-genie", name: "Safety Genie – Q&A Accuracy", inter_rater_count: 1 },
  { id: "uc-safety-vision", name: "Safety Vision – PPE Detection", inter_rater_count: 2 },
  { id: "uc-custom-ergo", name: "Custom – Ergo Risk Scoring", inter_rater_count: 1 },
];

export const SAMPLE_TASKS: AuditTask[] = [
  {
    id: "task-0001-abcd-1234-efgh",
    use_case_id: "uc-safety-genie",
    status: TASK_STATUS.CLAIMED,
    assigned_to: "sample-auditor",
    priority: 2,
    created_at: "2026-01-10T08:00:00Z",
  },
  {
    id: "task-0002-abcd-1234-efgh",
    use_case_id: "uc-safety-vision",
    status: TASK_STATUS.AVAILABLE,
    assigned_to: "sample-auditor",
    priority: 1,
    created_at: "2026-01-11T10:30:00Z",
  },
  {
    id: "task-0003-abcd-1234-efgh",
    use_case_id: "uc-safety-genie",
    status: TASK_STATUS.COMPLETED,
    assigned_to: "sample-auditor",
    priority: 0,
    created_at: "2026-01-08T14:00:00Z",
  },
  {
    id: "task-0004-abcd-1234-efgh",
    use_case_id: "uc-safety-vision",
    status: TASK_STATUS.COMPLETED,
    assigned_to: "sample-auditor",
    priority: 0,
    created_at: "2026-01-07T09:00:00Z",
  },
  {
    id: "task-0005-abcd-1234-efgh",
    use_case_id: "uc-custom-ergo",
    status: TASK_STATUS.EXPIRED,
    assigned_to: "sample-auditor",
    priority: 0,
    created_at: "2026-01-01T12:00:00Z",
  },
  {
    id: "task-0006-abcd-1234-efgh",
    use_case_id: "uc-safety-vision",
    status: TASK_STATUS.AVAILABLE,
    assigned_to: "sample-auditor",
    priority: 3,
    created_at: "2026-01-12T07:00:00Z",
  },
];

export const SAMPLE_RESULTS: AuditResult[] = [
  {
    id: "res-001",
    task_id: "task-0003-abcd-1234-efgh",
    auditor_id: "sample-auditor",
    status: RESULT_STATUS.SUBMITTED,
    decisions: { accuracy: { decision: "correct" }, completeness: { decision: "correct" } },
  },
  {
    id: "res-002",
    task_id: "task-0004-abcd-1234-efgh",
    auditor_id: "sample-auditor",
    status: RESULT_STATUS.SUBMITTED,
    decisions: { bbox_quality: { decision: "correct" }, label_match: { decision: "incorrect" } },
  },
  {
    id: "res-003",
    task_id: "task-0004-abcd-1234-efgh",
    auditor_id: "reviewer02",
    status: RESULT_STATUS.SUBMITTED,
    decisions: { bbox_quality: { decision: "correct" }, label_match: { decision: "correct" } },
  },
  {
    id: "res-004",
    task_id: "task-0002-abcd-1234-efgh",
    auditor_id: "sample-auditor",
    status: RESULT_STATUS.DRAFT,
    decisions: {},
  },
];
